import { ButtonBase, List, ListItem, Typography } from "@material-ui/core";
import { useState } from "react";
import { ReactComponent as ChevronUp } from "icons/ChevronUp.svg";
import { ReactComponent as ChevronDown } from "icons/ChevronDown.svg";
import { mapOverlaysControlStyles } from "./MapOverlaysControlStyles";
import { MapOverlaysControlProps } from "./MapOverlaysControlProps";
import { ReactComponent as Check } from "icons/Check.svg";

export function MapOverlaysControl({
    selected,
    overlays,
    onChange,
}: MapOverlaysControlProps) {
    const [expanded, setExpanded] = useState(false);

    const classes = mapOverlaysControlStyles({ expanded });

    const handleItemClick = (name: string) => {
        const newSelected = selected.includes(name)
            ? selected.filter((x) => x !== name)
            : [...selected, name];
        onChange(newSelected);
    };

    return (
        <div className={classes.root}>
            <ButtonBase
                onClick={() => setExpanded((prev) => !prev)}
                className={classes.button}
            >
                <Typography variant="body1">Map Overlay</Typography>
                {expanded ? <ChevronUp /> : <ChevronDown />}
            </ButtonBase>
            {expanded && (
                <List className={classes.list}>
                    {overlays.map((x) => (
                        <ListItem
                            key={x.name}
                            button
                            onClick={() => handleItemClick(x.name)}
                            selected={selected.includes(x.name)}
                            className={classes.itemRoot}
                        >
                            {selected.includes(x.name) && (
                                <Check style={{ marginRight: "10px" }} />
                            )}
                            {x.displayName}
                        </ListItem>
                    ))}
                </List>
            )}
        </div>
    );
}
